import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

// --- ICONOS SVG EXACTOS (Lucide React) ---

function RefreshCwIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
      <path d="M8 16H3v5" />
    </svg>
  );
}

function HeartIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );
}

function StarIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

function UsersIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

// Selección de icono según la letra del pilar
function getPillarIcon(letter) {
  switch (letter) {
    case "R":
      return RefreshCwIcon;
    case "E":
      return HeartIcon;
    case "V":
      return StarIcon;
    case "I":
      return UsersIcon;
    default:
      return StarIcon;
  }
}

export function Pillars({ items = [] }) {
  const { t } = useLandingLang();
  return (
    <section id="pilares" className="py-24 px-6 text-center bg-slate-50">
      <div className="max-w-7xl mx-auto">
        {/* CABECERA */}
        <div className="mb-16">
          <span className="text-sky-500 !font-black tracking-widest uppercase text-xs">
            {t("pillarsTag")}
          </span>
          <h2 className="text-4xl !font-black mt-2 tracking-tight text-slate-700">
            {t("pillarsTitle")}
          </h2>
        </div>

        {/* GRID DE PILARES */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((pillar, i) => {
            const Icon = getPillarIcon(pillar.letter);

            return (
              <div
                key={i}
                // Card con estilos exactos: rounded-[2.5rem], hover:-translate-y-2
                className="group bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-sky-100 transition-all duration-500 hover:-translate-y-2 flex flex-col items-center lg:items-start text-center lg:text-left"
              >
                {/* ICONO: Gradiente, rotación en hover */}
                <div
                  className={`w-14 h-14 bg-gradient-to-br ${pillar.color} rounded-2xl flex items-center justify-center mb-8 text-white shadow-lg shadow-sky-100 group-hover:rotate-12 transition-transform`}
                >
                  <Icon className="w-6 h-6" />
                </div>

                {/* TÍTULO: Letra Grande + Resto de la palabra */}
                <h3 className="text-2xl !font-black mb-4 flex items-baseline gap-1 justify-center lg:justify-start">
                  <span className={`text-4xl ${pillar.letterColor}`}>
                    {t(pillar.letterKey)}
                  </span>
                  <span className="text-slate-700">{t(pillar.titleKey)}</span>
                </h3>

                {/* DESCRIPCIÓN */}
                <p className="text-slate-500 text-sm leading-relaxed font-medium">
                  {t(pillar.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
